import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setVisible(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        bgcolor: '#1e1e1e',
        color: '#fff',
        p: 2,
        zIndex: 9999,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      <Typography variant="body2">
        Utilizziamo cookie tecnici e analitici anonimi per migliorare la tua esperienza.
        Continuando accetti l’uso dei cookie.
      </Typography>

      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button variant="outlined" color="inherit" onClick={rejectCookies}>
          Rifiuta
        </Button>
        <Button variant="contained" onClick={acceptCookies}>
          Accetta
        </Button>
      </Box>
    </Box>
  );
}